export class DataChange {
    static readonly type = '[EnumResolver] DataChange';

    constructor(public payload: any) {}
}
